import { useEffect, useState } from "react";
import { ChatSession, emptyChat } from "./chat-session";

export function useChatSession() {
  const [chat, setChat] = useState(emptyChat);
  const [chatController] = useState(() => new ChatSession(setChat));
  useEffect(() => () => chatController.reset(), [chatController]);
  return { chat, chatController };
}
